import axios from 'axios'

const CSRF_COOKIE_ROUTE = '/api/v2/sanctum/csrf-cookie'
const FALLBACK_CSRF_ROUTE = '/sanctum/csrf-cookie'
let csrfRefreshPromise = null

const shouldRetryOnCsrfFailure = (error) => error?.response?.status === 419

export const ensureCsrfCookie = async () => {
  if (csrfRefreshPromise) {
    return csrfRefreshPromise
  }

  csrfRefreshPromise = (async () => {
    try {
      await axios.get(CSRF_COOKIE_ROUTE, { withCredentials: true })
    } catch (error) {
      if (error?.response?.status === 404 && CSRF_COOKIE_ROUTE !== FALLBACK_CSRF_ROUTE) {
        await axios.get(FALLBACK_CSRF_ROUTE, { withCredentials: true })
        return
      }
      throw error
    } finally {
      csrfRefreshPromise = null
    }
  })()

  return csrfRefreshPromise
}

export const postWithCsrfRetry = async (url, payload, config = {}) => {
  const requestConfig = { withCredentials: true, ...config }

  try {
    return await axios.post(url, payload, requestConfig)
  } catch (error) {
    if (shouldRetryOnCsrfFailure(error)) {
      await ensureCsrfCookie()
      return await axios.post(url, payload, requestConfig)
    }

    throw error
  }
}
